module.exports = __webpack_public_path__ + "img/topimg@2x.c9712d3d.png";